"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLoadFlow = dataLoadFlow;

var _effects = require("redux-saga/effects");

var _lodash = _interopRequireDefault(require("lodash"));

var dataViewTypes = _interopRequireWildcard(require("../views/types"));

var dataFiltersTypes = _interopRequireWildcard(require("../filters/types"));

var filterValueTypes = _interopRequireWildcard(require("../../filters/value/types"));

var apiDataActions = _interopRequireWildcard(require("../../apiFlow/data/actions"));

var _selectors = require("../views/selectors");

var _component = require("../../../constants/component");

var _types4 = require("../../partnerEmulation/types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(reloadDataViews),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(dataLoadFlow);

function reloadDataViews(reloadedDataViews, abortController) {
  var reloadedDataTypes, dataType;
  return regeneratorRuntime.wrap(function reloadDataViews$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          reloadedDataTypes = {};

          _lodash["default"].forEach(reloadedDataViews, function (dataView) {
            reloadedDataTypes[dataView[_component.PROPS.DATA_TYPE].type] = dataView[_component.PROPS.DATA_TYPE];
          });

          _context.t0 = regeneratorRuntime.keys(reloadedDataTypes);

        case 3:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 9;
            break;
          }

          dataType = _context.t1.value;
          _context.next = 7;
          return (0, _effects.put)(apiDataActions.saga(reloadedDataTypes[dataType], abortController));

        case 7:
          _context.next = 3;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function dataLoadFlow() {
  var filterFormDataViewsStack, action, id, state, dataView, _action$payload, _id, props, _state, _dataView, _action$payload3, dataType, isViewUpdateRequired, _state3, reloadedDataViews, _state4, dataViews, _reloadedDataViews;

  return regeneratorRuntime.wrap(function dataLoadFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          filterFormDataViewsStack = []; // Because sagas are generators, doing `while (true)` doesn't block our program
          // Basically here we say "this saga is always listening for core.actions"

        case 1:
          if (!true) {
            _context3.next = 47;
            break;
          }

          _context3.next = 4;
          return (0, _effects.take)('*');

        case 4:
          action = _context3.sent;

          if (!(action.type === dataViewTypes.MOUNT)) {
            _context3.next = 17;
            break;
          }

          id = action.payload.id;
          _context3.next = 9;
          return (0, _effects.select)();

        case 9:
          state = _context3.sent;
          dataView = (0, _selectors.getDataView)(state, id);

          if (!dataView[_component.PROPS.FILTER_TYPE]) {
            _context3.next = 15;
            break;
          }

          // ... if data view got filter type put to stack to get data after filter form options be preloaded
          filterFormDataViewsStack.push(dataView);
          _context3.next = 17;
          break;

        case 15:
          _context3.next = 17;
          return (0, _effects.put)(apiDataActions.saga(dataView[_component.PROPS.DATA_TYPE]));

        case 17:
          if (!(action.type === dataViewTypes.UPDATE_PROPS)) {
            _context3.next = 26;
            break;
          }

          _action$payload = action.payload, _id = _action$payload.id, props = _action$payload.props;
          _context3.next = 21;
          return (0, _effects.select)();

        case 21:
          _state = _context3.sent;
          _dataView = (0, _selectors.getDataView)(_state, _id);

          if (!props.hasOwnProperty(_component.PROPS.DATA_TYPE)) {
            _context3.next = 26;
            break;
          }

          _context3.next = 26;
          return (0, _effects.put)(apiDataActions.saga(_dataView[_component.PROPS.DATA_TYPE]));

        case 26:
          if (!(action.type === filterValueTypes.PRELOAD_COMPLETE)) {
            _context3.next = 28;
            break;
          }

          return _context3.delegateYield(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee() {
            var _action$payload2, filterTypes, onMount, abortController, reloadedDataViews, _state2;

            return regeneratorRuntime.wrap(function _callee$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _action$payload2 = action.payload, filterTypes = _action$payload2.filterTypes, onMount = _action$payload2.onMount, abortController = _action$payload2.abortController;
                    reloadedDataViews = []; // If apply complete on mount process...

                    if (!onMount) {
                      _context2.next = 6;
                      break;
                    }

                    // ... get data view from preload stack
                    reloadedDataViews = _lodash["default"].remove(filterFormDataViewsStack, function (dataView) {
                      return filterTypes.includes(dataView.filterType);
                    });
                    _context2.next = 10;
                    break;

                  case 6:
                    _context2.next = 8;
                    return (0, _effects.select)();

                  case 8:
                    _state2 = _context2.sent;
                    reloadedDataViews = (0, _selectors.getDataViewsByFilterTypes)(_state2, filterTypes);

                  case 10:
                    _context2.next = 12;
                    return (0, _effects.call)(reloadDataViews, reloadedDataViews, abortController);

                  case 12:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee);
          })(), "t0", 28);

        case 28:
          if (!(action.type === dataFiltersTypes.APPLY)) {
            _context3.next = 37;
            break;
          }

          _action$payload3 = action.payload, dataType = _action$payload3.dataType, isViewUpdateRequired = _action$payload3.isViewUpdateRequired;
          _context3.next = 32;
          return (0, _effects.select)();

        case 32:
          _state3 = _context3.sent;

          if (!isViewUpdateRequired) {
            _context3.next = 37;
            break;
          }

          reloadedDataViews = (0, _selectors.getDataViewsByDataType)(_state3, dataType);
          _context3.next = 37;
          return (0, _effects.call)(reloadDataViews, reloadedDataViews);

        case 37:
          if (!(action.type === _types4.ENABLE || action.type === _types4.DISABLE)) {
            _context3.next = 45;
            break;
          }

          _context3.next = 40;
          return (0, _effects.select)();

        case 40:
          _state4 = _context3.sent;
          dataViews = (0, _selectors.getAllDataViews)(_state4);
          _reloadedDataViews = dataViews.filter(function (dataView) {
            return !dataView[_component.PROPS.FILTER_TYPE];
          });
          _context3.next = 45;
          return (0, _effects.call)(reloadDataViews, _reloadedDataViews);

        case 45:
          _context3.next = 1;
          break;

        case 47:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}